import { createContext } from 'preact'
import { INITIAL_STATE } from './provider'
import { iStore } from '../../types/store'

export const StoreContext = createContext<iStore>(INITIAL_STATE)
